var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("page-settings")))]),
      _c(
        "w-card-content",
        [
          !_vm.useCustomFormat
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          value: _vm.selectedFormat,
                          label: _vm.$ct("format"),
                          items: _vm.pageFormatItems,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setFormat($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-link",
                        {
                          style: { userSelect: "none" },
                          on: {
                            click: function ($event) {
                              _vm.useCustomFormat = true
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("use-custom-page-format")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "6" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          min: 10,
                          max: 10000,
                          label: _vm.$ct("width-mm"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.value.Width,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "Width", $$v)
                          },
                          expression: "value.Width",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "6" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          min: 10,
                          max: 10000,
                          label: _vm.$ct("height-mm"),
                          fancy: "",
                        },
                        model: {
                          value: _vm.value.Height,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "Height", $$v)
                          },
                          expression: "value.Height",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-link",
                        {
                          style: { userSelect: "none" },
                          on: {
                            click: function ($event) {
                              return _vm.useDefaultFormat()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("use-default-page-format")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("marginTop"), fancy: "" },
                    model: {
                      value: _vm.value.MarginTop,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "MarginTop", $$v)
                      },
                      expression: "value.MarginTop",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("marginRight"), fancy: "" },
                    model: {
                      value: _vm.value.MarginRight,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "MarginRight", $$v)
                      },
                      expression: "value.MarginRight",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("marginBottom"), fancy: "" },
                    model: {
                      value: _vm.value.MarginBottom,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "MarginBottom", $$v)
                      },
                      expression: "value.MarginBottom",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("marginLeft"), fancy: "" },
                    model: {
                      value: _vm.value.MarginLeft,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "MarginLeft", $$v)
                      },
                      expression: "value.MarginLeft",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("headerHeight"), fancy: "" },
                    on: {
                      blur: function ($event) {
                        _vm.value.HeadingHeight = _vm.headingHeightBuffer
                      },
                    },
                    model: {
                      value: _vm.headingHeightBuffer,
                      callback: function ($$v) {
                        _vm.headingHeightBuffer = $$v
                      },
                      expression: "headingHeightBuffer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { label: _vm.$ct("footerHeight"), fancy: "" },
                    on: {
                      blur: function ($event) {
                        _vm.value.FooterHeight = _vm.footerHeightBuffer
                      },
                    },
                    model: {
                      value: _vm.footerHeightBuffer,
                      callback: function ($$v) {
                        _vm.footerHeightBuffer = $$v
                      },
                      expression: "footerHeightBuffer",
                    },
                  }),
                ],
                1
              ),
              _vm._t("default"),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }